export default "__VITE_ASSET__DSm8JrVP__"